var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.279,
    style: {
      fill: "#FAB446"
    },
    width: 512,
    height: 170.48
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.241,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.48
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.761,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M256,314.451c-32.229,0-58.448-26.219-58.448-58.448s26.219-58.448,58.448-58.448   s58.448,26.219,58.448,58.448S288.229,314.451,256,314.451z M256,208.429c-26.235,0-47.574,21.339-47.574,47.574   s21.339,47.574,47.574,47.574s47.574-21.339,47.574-47.574S282.235,208.429,256,208.429z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41479B"
    },
    cx: 256,
    cy: 256.001,
    r: 6.626
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,256.997 239.161,258.697 202.989,256.997 202.989,255.009 239.161,253.309 256,255.009     "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,256.997 272.839,258.697 309.011,256.997 309.011,255.009 272.839,253.309 256,255.009     "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.006,256.003 253.306,239.164 255.006,202.992 256.994,202.992 258.694,239.164    256.994,256.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.006,256.003 253.306,272.842 255.006,309.014 256.994,309.014 258.694,272.842    256.994,256.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.297,256.706 242.188,246.001 217.813,219.221 219.218,217.816 245.998,242.191    256.703,255.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.297,256.706 266.002,269.815 292.782,294.19 294.187,292.785 269.812,266.005    256.703,255.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.297,255.3 266.002,242.191 292.782,217.816 294.187,219.221 269.812,246.001    256.703,256.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.297,255.3 242.188,266.005 217.813,292.785 219.218,294.19 245.998,269.815    256.703,256.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256.38,256.921 241.474,264.936 207.404,277.208 206.644,275.371 239.412,259.958    255.62,255.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256.38,256.921 272.588,252.048 305.356,236.635 304.596,234.798 270.526,247.07    255.62,255.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.082,256.383 247.067,241.477 234.795,207.407 236.632,206.647 252.045,239.415    256.918,255.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.082,256.383 259.955,272.591 275.368,305.359 277.205,304.599 264.933,270.529    256.918,255.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.62,256.921 239.412,252.048 206.644,236.635 207.404,234.798 241.474,247.07    256.38,255.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.62,256.921 270.526,264.936 304.596,277.208 305.356,275.371 272.588,259.958    256.38,255.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.082,255.623 259.955,239.415 275.368,206.647 277.205,207.407 264.933,241.477    256.918,256.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "255.082,255.623 247.067,270.529 234.795,304.599 236.632,305.359 252.045,272.591    256.918,256.383  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 256.001,
    r: 7.257
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41479B"
    },
    cx: 256,
    cy: 256.001,
    r: 5.359
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.43ce6979c7aafa39470958a3450a68a8.svg";
export { ForwardRef as ReactComponent };